import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type Inquiry = {
  inquiry_id?: number; // 문의 idx
  user_id?: number; // 유저 idx
  admin_id?: number; // 관리자 idx
  shop_information_id?: number; // 쇼/브/매/지 idx
  product_id?: number; // 상품 idx
  inquiry_type?: string; // 문의 타입
  inquiry_answer?: string; // 문의 답변
  inquiry_name?: string; // 문의명
  inquiry_content?: string; // 문의 내용
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] Inquiry
   * --
   */
  getInquiries: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_INQUIRY, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] Inquiry
   * --
   */
  getInquiry: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_INQUIRY, { inquiry_id: idx });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Inquiry
   * --
   */
  createInquiry: async (body: Inquiry) => {
    try {
      const res = await $http.post(APIConstant.CREATE_INQUIRY, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Inquiry
   * --
   */
  updateInquiry: async (body: Inquiry) => {
    try {
      const { inquiry_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_INQUIRY, {
        inquiry_id: inquiry_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Inquiry
   * --
   */
  deleteInquiry: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_INQUIRY, {
        inquiry_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
